import { styled } from '@material-ui/core';

export const OuterWrapper = styled('div')({
  position: 'relative',
  width: '100%',
  height: 0,
  paddingBottom: (props: { ratio: number }) => `${(1 / props.ratio) * 100}%`,
});

export const InnerWrapper = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});
